import styled from "styled-components";
import {BalanceValueBonusAndCashDefaultBox} from "./balance-value-bonus-and-cash.default.box";

export const BalanceValueBonusAndCashWSOPBox = styled(BalanceValueBonusAndCashDefaultBox)`
    ${({theme}) => theme.font.presets.body}
`;
